import RestClient from '../../../../../api/axiosInterceptor';
import {
  patientForgotPasswordActions,
  patientResetPasswordActions
} from '../../../../actions/user/patient/auth/forgot_password';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    // Dispatch the request action before making the API call
    dispatch({ type: actionType.REQUEST });

    // Make the API call and wait for the response
    const response = await apiCall();

    // Dispatch the success action with the response data on success
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data // Store the response data
    });
    return response;
  } catch (error) {
    // Dispatch the failure action if an error occurs
    dispatch({
      type: actionType.FAILURE,
      payload: error.response?.data?.message || error.message // Use error message from response or fallback to error.message
    });
  }
};

// Action creator for patient forgot password
export const patientForgotPassword = (email) =>
  createAsyncAction(patientForgotPasswordActions.FORGOT_PASSWORD, () =>
    RestClient.post(
      '/patient/forgot-password',
      { email },
      { headers: { 'Content-Type': 'application/json' } }
    )
  );

// Action creator for patient reset password
export const patientResetPassword = (uid, token, passwordData) =>
  createAsyncAction(patientResetPasswordActions.RESET_PASSWORD, () =>
    RestClient.post(`/patient/reset-password/${uid}/${token}/`, passwordData, {
      headers: { 'Content-Type': 'application/json' }
    })
  );
